// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BackArrowLeft from "@ces/XDL/Icons/BackArrowLeft";
import RightNav from "@ces/XDL/Icons/RightNav";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        bodyColor: "common.ui1",
        childTypographyProps: {
            size: 14,
            lineHeight: "22px",
            weight: fontConfig.weight.regular,
            color: "text",
        },
        panelRowProps: {
            color: "common.ui1",
            moreIconProps: {
                color: "primary",
                src: RightNav,
                css: css`
                    &&& {
                        flex-grow: 1;
                        min-width: 38px;
                        height: 100%;
                        justify-content: flex-end;
                    }
                    & > svg {
                        height: 22px;
                        width: 7px;
                    }
                `,
            },
        },
        backIconProps: {
            src: BackArrowLeft,
            size: 14,
        },
    },
} as xBaseTheme["panelMenu"];
